import { toQueryParams } from "utils/http/params";
import { dataApi } from "./DataService";

const reportApi = dataApi
  .enhanceEndpoints({addTagTypes: ['report', 'reportTypes']})
  .injectEndpoints({
    endpoints: (builder) => ({
      getReportTypes: builder.query({
        query: () => ({
          url: '/reports/types'
        }),
        providesTags: ['reportTypes']
      }),
      getReport: builder.query({
        query: (arg) => ({
          url: '/reports',
          params: toQueryParams(arg)
        }),
        transformResponse: (response, meta, arg) => {
          const editedItems = response.body.items.map( (item, index) => ({...item, virtualId: index}) );
          response.body.items = editedItems;
          return response;
        },
        providesTags: ['report']
      })
    })  
  });

export const {
  useLazyGetReportQuery,
  useGetReportTypesQuery
} = reportApi;